import { RDEqipEligibilityFarmInfo } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { FarmInfoTaskEditor } from './FarmInfoEditor'

export const RDEqipEligibilityFarmInfoDetailFeature: ResourceDetailFeature<RDEqipEligibilityFarmInfo> =
  {
    traitId: 'eqipEligibilityFarmInfo',
    TaskEditor: FarmInfoTaskEditor,
  }
